export default __webpack_public_path__ + "static/media/annualreport.63883fee.svg";